import { MoonPayProvider, MoonPayBuyWidget } from '@moonpay/moonpay-react';
import {useEffect} from 'react';

export default () => {
    return (
        <MoonPayProvider apiKey="pk_test_aiciTIVYN2ZKiUe3kDLpspY9CbNZncD" debug>
            <MoonPayBuyWidget
                variant="overlay"
                baseCurrencyCode="usd"
                baseCurrencyAmount="100"
                defaultCurrencyCode="eth"
                visible={true}
            />
        </MoonPayProvider>
    )
}